import React, { Component } from 'react';
import { entityLabelMatcher } from '../../helpers/label-mapper';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GeoSearchInput from '../../components/geo-search-input';
import SearchMapContainer from '../../components/search-map-container';
import * as selectors from '../../reducers';
import styles from './search-page.module.scss';
import {
  setActiveRegion,
  setActivePage,
  setActiveEntity,
} from '../../actions/ui';
import { ChevronDoubleRight } from '../../components/icons';
import { entityTypes } from '../../config';

class SearchPage extends Component {
  constructor() {
    super();
    this.selectCouncil = this.selectCouncil.bind(this);
    this.handleListClick = this.handleListClick.bind(this);
  }
  selectCouncil(councilId) {
    const { setActiveRegion, setActivePage } = this.props;

    console.log('IDDDD', councilId);

    setActiveRegion(councilId);
    setActivePage('region');
  }

  selectEntity(entityId) {
    const { setActiveEntity, setActivePage } = this.props;

    setActiveEntity(entityId);
    setActivePage('entity');
  }

  handleListClick(council) {
    return (e) => {
      window.scrollTo(0, 0);
      this.selectCouncil(council.id);
    };
  }

  handleEntityListClick(entity) {
    return (e) => {
      window.scrollTo(0, 0);
      this.selectEntity(entity.id);
    };
  }

  renderRegions() {
    const { regions } = this.props;
    return (
      <ul className={styles.councilList}>
        {regions
          .filter((c) => {
            // Don't make a page for the "Other- inside or outside QLD" category
            return !c.name.includes('Other');
          })
          .map((council, i) => (
            <li key={i} className={styles.councilListElement}>
              <button
                type="button"
                className={styles.councilListElementButton}
                onClick={this.handleListClick(council)}
              >
                {council.name}
              </button>
            </li>
          ))}
      </ul>
    );
  }
  render() {
    return (
      <div>
        <div className={styles.searchPageHeader}>
          <div className={styles.mainHeading}>
            Understanding your transport services in 2020
          </div>
          <hr className={styles.mainHeadingLine} />
          <div className={styles.subHeading}>
            Our interactive map of Queensland allows you to explore and compare
            the financial performance of Queensland’s transport entities. You
            can explore infrastructure investment for the Department of
            Transport and Main Roads and the state’s rail and port entities;
            road lengths and the number of bridges; transport modes; and the key
            commodities managed by ports. Find information on your transport
            services by typing your address into the search bar or clicking on
            your local council.
          </div>
        </div>
        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Search the map</h3>
          <div className={styles.searchWrapper}>
            <GeoSearchInput onCouncilSelect={this.selectCouncil} />
          </div>
          <div className={styles.mapRow}>
            <div className={styles.mapWrapper}>
              <SearchMapContainer onCouncilSelect={this.selectCouncil} />
            </div>
            <div className={styles.entityListWrapper}>
              {Object.keys(entityTypes).map((entityType, i) => {
                return (
                  <div key={entityType + i}>
                    <h4 className={styles.smallerCouncilHeadline}>
                      {entityLabelMatcher(entityType, 'plural')}
                    </h4>
                    <ul className={styles.searchEntityList}>
                      {this.props.entities
                        .filter((e) => e.listCategory.includes(entityType))
                        .map((e) => {
                          return (
                            <li
                              onClick={this.handleEntityListClick(e)}
                              key={e.name}
                              role="button"
                              className={styles.li}
                            >
                              <ChevronDoubleRight
                                fill="blue"
                                width="10px"
                                height="10px"
                                style={{
                                  marginRight: 10,
                                  height: 10,
                                  width: 10,
                                }}
                              />
                              {e.name}
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Select LGA from list</h3>
          <div className={styles.listWrapper}>{this.renderRegions()}</div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActiveRegion,
  setActivePage,
  setActiveEntity,
};

const mapStateToProps = (state) => ({
  regions: selectors.getRegions(state),
  entities: selectors.getEntities(state),
});

SearchPage.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.object),
  entities: PropTypes.arrayOf(PropTypes.object),
  setActiveRegion: PropTypes.func,
  setActivePage: PropTypes.func,
  setActiveEntity: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);



// WEBPACK FOOTER //
// ./src/pages/search-page/search-page.js